module.exports = __webpack_public_path__ + "static/img/severance-design.87b61da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/severance-design.jpg
// module id = vwqo
// module chunks = 0